import { render, staticRenderFns } from "./AppNoticeDetail.vue?vue&type=template&id=362190f6&scoped=true"
import script from "./AppNoticeDetail.vue?vue&type=script&lang=js"
export * from "./AppNoticeDetail.vue?vue&type=script&lang=js"
import style0 from "./AppNoticeDetail.vue?vue&type=style&index=0&id=362190f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362190f6",
  null
  
)

export default component.exports